<template>
  <div class="home-validator">
    <ContentHome />
  </div>
</template>

<script>
import ContentHome from "../Home/ContentHome/CustomAppraiser.vue";

export default {
  components: {
    ContentHome
  }
};
</script>
